// import { Typography } from '@mui/material'
// import React from 'react'

// const UnAuthorized = () => {
//   return (
//     <Typography>Page not found</Typography>
//   )
// }

// export default UnAuthorizedimport { Box, Typography } from '@mui/material';
import { Box, Typography } from '@mui/material';
import React from 'react';

const UnAuthorized = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Typography variant="h4" color="textSecondary">
        Page not found
      </Typography>
    </Box>
  );
};

export default UnAuthorized;
